import store from '@/store';
import { Role } from '@/data/roles'


export default class UserService {
	hasRole = (role) => {
		return store.getters.CurrentUser.role === role;
	};

	isAdmin = () => {
		return store.getters.CurrentUser.role === Role.Admin;
	};

	getUserId = () => {
		return store.getters.CurrentUser.id
	};
}